





















































































import { Component} from 'vue-property-decorator';
import Print from "./print.class";

@Component
export default class PrintEcoplantMap extends Print {
  Title:string = '';
  TheDonut: any = {};
  TheTotals = [];
  Charts = [];
  ChartsMore = [];
  isYieldEcoplant: boolean = false;
  isSmallOrMobile: boolean = false;

  async created() {
    this.ChartsMore = [];
    let cache = this.$store.getters.Storage;
    if (cache) {
      for (let p in cache) {
        this[p] = cache[p];
      }
      let n = this.Charts.length;
      if (n>2) {
        this.ChartsMore = this.Charts.splice(2,n-2);
      }
      /*
      this.Title = cache.Title;
      this.TheDonut = cache.TheDonut;
      this.TheTotals = cache.TheTotals;
      this.Charts = cache.Charts;
      this.isYieldEcoplant = cache.isYieldEcoplant;
      this.isSmallOrMobile = cache.isSmallOrMobile;
      */
    }
  }
}
